import "./index.css";
// Import the all-mighty AlpineJS
import Alpine from "alpinejs";

import App from "./modules/app";
import {initMobileMenu} from "./modules/mmenu";
import {initSwiper} from "./modules/cdu_swiper";
import {createPopper} from "@popperjs/core";

import Swiper from 'swiper/swiper';

App(() => {
    initMobileMenu();
    initSwiper();
    Alpine.start();

});

declare global {
    var context: {
        fetch_url: string;
        post_id: number;
        ajax_url: string;
        ajax_nonce: string;
    };
}

document.addEventListener("DOMContentLoaded", function () {
    // insert typescript code here

    const submenus = document.querySelectorAll<HTMLElement>(
        ".menu-item.parent.menu-item-has-children"
    );

    submenus.forEach((el: HTMLElement) => {
        let submenuEl: HTMLElement = el.lastElementChild as HTMLElement;

        console.log(submenuEl);

        createPopper(el, submenuEl, {
            placement: "bottom-start",
        });
    });

    const downloadBox = document.querySelectorAll(".c-img-downloadbox");

    downloadBox.forEach((element) => {
        element.addEventListener("click", (event) => {
            console.log(event);

            if (event.target instanceof HTMLElement) {
                event.target.classList.toggle("open");
                let set = event.target.dataset;

                if (set.state == "open") {
                    set.state = "closed";
                } else {
                    set.state = "open";
                }
            }
        });
    });

    var slider = new Swiper(".js-slider", {
        loop: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
        },
    });
});
